import { getEnv } from "../runtimeEnv";

const SCRIPT_ID = "sa-recaptcha-v3";

export function getRecaptchaSiteKey() {
  if (getEnv("REACT_APP_CAPTCHA_VISIBLE") === "false") return "";
  return String(getEnv("REACT_APP_RECAPTCHA_SITE_KEY") || "").trim();
}

export function loadRecaptcha() {
  const siteKey = getRecaptchaSiteKey();
  if (!siteKey || typeof document === "undefined") return Promise.resolve(false);
  if (window.grecaptcha?.execute) return Promise.resolve(true);

  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      if (window.grecaptcha?.execute) {
        resolve(true);
        return;
      }
      existing.addEventListener("load", () => resolve(true), { once: true });
      existing.addEventListener("error", () => reject(new Error("Couldn't load reCAPTCHA.")), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error("Couldn't load reCAPTCHA."));
    document.head.appendChild(script);
  });
}

/** Returns a v3 token. An empty site key skips verification and returns "". */
export async function getRecaptchaToken(action) {
  const siteKey = getRecaptchaSiteKey();
  if (!siteKey) return "";
  await loadRecaptcha();
  if (!window.grecaptcha?.execute) {
    throw new Error("Couldn't load reCAPTCHA.");
  }
  await new Promise((resolve) => window.grecaptcha.ready(resolve));
  const token = await window.grecaptcha.execute(siteKey, { action });
  if (!token) throw new Error("Couldn't verify this sign-in. Please try again.");
  return token;
}
